import createDappAsyncThunk from "#/redux-state/asyncThunk"

import {
  addNewOrderToHistory,
  mergeOrdersHistory,
  setIsOrdersHistoryFetching,
} from "../slices/store"

export const orderProduct = createDappAsyncThunk(
  "store/orderProduct",
  async (
    { productId }: { productId: number },
    { dispatch, extra: { sdk } },
  ) => {
    const orderResponse = await sdk.mezo.chain?.storeModule.order(productId)
    if (orderResponse?.hash) {
      let order
      let retryCount = 0

      // Here we have to get the order we've just made in GraphQL, so that we
      // can use it's order it to claim the code. GraphQL might need some time
      // to update the data, so we try to call the endpoint 4 times.
      /* eslint-disable no-await-in-loop */
      while (!order && retryCount < 4) {
        await new Promise((resolve) => {
          setTimeout(resolve, 5000)
        })
        // We have to call getOrders here instead of getOrder(transactionHash)
        // because for some reason filtering the transactions in GraphQL by
        // `_transactionHash` property does not work (probably because of the
        // underscore at the beginning).
        const orders = await sdk.mezo.api.store.getOrders()
        order = orders.find((o) => o.transactionHash === orderResponse.hash)
        retryCount += 1
      }

      if (!order) return undefined

      dispatch(addNewOrderToHistory(order))

      const { redemptionCode } = await sdk.mezo.api.store.claimRedemptionCode(
        order.orderId,
      )

      return { transactionHash: orderResponse.hash, redemptionCode }
    }

    return undefined
  },
)

export const fetchOrdersHistory = createDappAsyncThunk(
  "store/fetchOrdersHistory",
  async (_, { getState, dispatch, extra: { sdk } }) => {
    const existingHistory = getState().store.ordersHistory

    if (existingHistory.length !== 0) return existingHistory

    dispatch(setIsOrdersHistoryFetching(true))
    const orders = await sdk.mezo.api.store.getOrders()
    dispatch(mergeOrdersHistory(orders))
    dispatch(setIsOrdersHistoryFetching(false))
    return orders
  },
)

export const claimRedemptionCodeForOrder = createDappAsyncThunk(
  "store/claimRedemptionCodeForOrder",
  async ({ orderId }: { orderId: number }, { extra: { sdk } }) => {
    const { redemptionCode } =
      await sdk.mezo.api.store.claimRedemptionCode(orderId)

    return redemptionCode ?? null
  },
)
